import { render, staticRenderFns } from "./DistributorUnitBasicInfo.vue?vue&type=template&id=3735ec43&scoped=true&"
import script from "./DistributorUnitBasicInfo.vue?vue&type=script&lang=js&"
export * from "./DistributorUnitBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./DistributorUnitBasicInfo.vue?vue&type=style&index=0&id=3735ec43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3735ec43",
  null
  
)

export default component.exports